import { idForPath, restDelete, restGet, restPatch, restPost } from "./restClient.js";

const ROOT = "/v1/litellm-integrations";

export function listLiteLlmIntegrations({ signal } = {}) {
    return restGet(ROOT, null, { signal });
}

export function createLiteLlmIntegration({ displayName }) {
    return restPost(ROOT, { display_name: displayName });
}

export function renameLiteLlmIntegration(integrationId, displayName) {
    return restPatch(`${ROOT}/${idForPath(integrationId)}`, { display_name: displayName });
}

export function rotateLiteLlmCredential(integrationId) {
    return restPost(`${ROOT}/${idForPath(integrationId)}:rotate-credential`, {});
}

export function deleteLiteLlmIntegration(integrationId) {
    return restDelete(`${ROOT}/${idForPath(integrationId)}`);
}
